import type { ScopeTierStatus } from '@/shared/hooks/api/radarScopeTier'

export const EXPERT_SPAN_REQUIRED_FOR_APPROVAL_MESSAGE =
  'Select expert scope text in the document body before approving tier 1 or tier 2.'

export function resolveEffectiveScopeTier(
  scopeTiers: number[]
): 1 | 2 | 3 | null {
  const effectiveTier = scopeTiers.reduce<number | null>(
    (maxTier, tier) => (maxTier === null ? tier : Math.max(maxTier, tier)),
    null
  )
  if (effectiveTier === 1 || effectiveTier === 2 || effectiveTier === 3) {
    return effectiveTier
  }
  return null
}

export function shouldPromptForTierBeforeApproval(input: {
  reviewStatus: ScopeTierStatus
  currentTier: 1 | 2 | 3 | null
}): boolean {
  return input.reviewStatus !== 'approved' && input.currentTier == null
}

function hasExpertSpanSelectedText(
  expertSpan: { selectedText: string } | null | undefined
): boolean {
  return Boolean(expertSpan?.selectedText?.trim())
}

export function requiresExpertSpanBeforeApproval(input: {
  reviewStatus: ScopeTierStatus
  currentTier: 1 | 2 | 3 | null
  scopeTiers?: number[]
  expertSpan: { selectedText: string } | null
  approvingTier?: 1 | 2 | 3
}): boolean {
  if (input.reviewStatus === 'approved') {
    return false
  }

  let tierForApproval: 1 | 2 | 3 | null = input.approvingTier ?? null
  if (tierForApproval == null) {
    if (input.scopeTiers && input.scopeTiers.length > 0) {
      tierForApproval = resolveEffectiveScopeTier(input.scopeTiers)
    } else {
      tierForApproval = input.currentTier
    }
  }

  if (tierForApproval !== 1 && tierForApproval !== 2) {
    return false
  }

  return !hasExpertSpanSelectedText(input.expertSpan)
}
